import styles from "./style.module.scss";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import TicIcon from "@components/shared/bestBuyers/icons/TicIcon";
import XIcon from "@components/shared/bestBuyers/icons/XIcon";
import { useQuery } from "@tanstack/react-query";
export default function ProsConsList({
    list,
    type,
}: {
    list?: string[];
    type?: string;
}) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <>
            <div>
                <h2 className="font-bold lg:text-lg lg:leading-8  text-base  leading-7 ">
                    {type === "pros"
                        ? translate(translations, "several_general_prosWord")
                        : translate(translations, "several_general_consWord")}
                </h2>
                <div className={`${styles["borderStyle"]} lg:mt-2 mt-3 pt-6 `}>
                    {list?.map((el, index) => {
                        return (
                            <div
                                key={index}
                                className="flex items-start lg:gap-3 gap-4 lg:mt-1 max-w-sm lg:ml-0 ml-4 "
                            >
                                {type === "pros" ? (
                                    <div
                                        className={`${styles["ticStyle"]} pt-2`}
                                    >
                                        <TicIcon color="#F9BB21" />
                                    </div>
                                ) : (
                                    <div className={`${styles["xStyle"]} pt-2`}>
                                        <XIcon color="#F9BB21" />
                                    </div>
                                )}
                                <div
                                    className={`ltr:leading-7 rtl:leading-[26px] ${styles["paragraphColor"]} text-sm lg:text-lg rtl:text-base`}
                                >
                                    {el}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
